var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3DSticker4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 210,
    viewBox: "0 0 172 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 118.434,
    y: -51.5,
    width: 76.6078,
    height: 76.6078,
    rx: 10.7349,
    transform: "rotate(45 118.434 -51.5)",
    fill: "#ABC452"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 157.828,
    y: 37.1406,
    width: 76.6078,
    height: 76.6078,
    rx: 10.7349,
    transform: "rotate(45 157.828 37.1406)",
    fill: "#ABC452"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 93.8086,
    y: 101.16,
    width: 76.6078,
    height: 76.6078,
    rx: 10.7349,
    transform: "rotate(45 93.8086 101.16)",
    fill: "#ABC452"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 54.4141,
    y: 12.5195,
    width: 76.6078,
    height: 76.6078,
    rx: 10.7349,
    transform: "rotate(45 54.4141 12.5195)",
    fill: "#ABC452"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DSticker4);
export default __webpack_public_path__ + "static/media/3d-sticker4.2a019dbb0cc1aef9b19ef9f5519cd2db.svg";
export { ForwardRef as ReactComponent };